// Re-export of the shared vocabulary (scripts/ ships in the browser bundle and is
// spliced into WF67; S-160 pins both). Components import from here, never ../scripts.
import { WITHDRAWAL_REASON_CODES as CODES, isWithdrawalCode as isCode, isCmsUnalignReason as isCms } from '../../../scripts/withdrawal-reason.mjs';

export {
  WITHDRAWAL_REASON_CODES,
  CMS_UNALIGN_REASONS,
  OTHER,
  NOTE_MAX,
  encodeWithdrawalReason,
  decodeWithdrawalReason,
  sanitizeNote,
  isWithdrawalCode,
  isCmsUnalignReason,
  withdrawalReasonLabel,
  cmsUnalignLabel,
} from '../../../scripts/withdrawal-reason.mjs';
export type {
  WithdrawalReasonOption,
  CmsUnalignReason,
  DecodedWithdrawalReason,
} from '../../../scripts/withdrawal-reason.mjs';

// A withdrawal request stores the code only, never a note: `op:<code>`, so Other is `op:other`.
export function encodeRequestReason(code: string | null | undefined): string | null {
  return isCode(code) ? `op:${code}` : null;
}

/** The CMS unalignment reason a withdrawal code maps to; null for deceased and duplicate/test. */
export function cmsReasonFor(code: string | null | undefined): string | null {
  const cms = CODES.find((r) => r.code === code)?.cms ?? null;
  return cms && isCms(cms) ? cms : null;
}
